import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, Card, CardContent, Loading } from '@guildeducationinc/recess';
import EditIcon from '@guildeducationinc/recess/icons/EditIcon';
import { Filter } from '@src/components/Filter';
import { useClientIdParam } from '@src/hooks/useClientIdParam';
import { DataTable, emptyFilter, TrackableButton, useFilters, useLocale, } from 'pe-core-frontend';
import { useState } from 'react';
import { AdminTopNav } from '../AdminTopNav';
export const Filters = () => {
    const clientId = useClientIdParam() || 0;
    const { t } = useLocale();
    const { items, loading, error } = useFilters({
        clientId,
    });
    const [selected, setSelected] = useState(null);
    // const [, setToDelete] = useState<Filter | null>(null);
    const handleSelected = (filter) => {
        setSelected(filter);
    };
    return (_jsxs("div", { children: [_jsx(AdminTopNav, { title: t('Policy') }), _jsxs(Loading, { label: 'Filters', loaded: !loading, showChildrenWhileLoading: true, overlay: true, children: [error && (_jsx(Alert, { display: true, hideClose: true, type: 'danger', children: error.message })), _jsx("div", { children: _jsx(TrackableButton, { enText: 'Add filter', tag: 'filters_list', appearance: 'primary', type: 'button', className: 'button button--primary margin--bottom_16', onClick: () => setSelected({ ...emptyFilter, clientId }), children: t('filters.add') }) }), _jsx(DataTable, { disableColumnMenu: true, disableRowSelectionOnClick: true, rows: items || [], hideFooter: true, columns: [
                            {
                                field: 'name',
                                headerName: t('Name'),
                                flex: 0.2,
                                sortable: false,
                            },
                            {
                                field: 'action',
                                headerName: t('Actions'),
                                renderCell: ({ row }) => (_jsx("div", { children: _jsx(TrackableButton, { btnType: 'icon', enText: 'Edit', tag: `filter_${row.id}`, label: t('Edit'), appearance: 'minimal', icon: _jsx(EditIcon, { size: 20 }), onClick: () => handleSelected(row), className: 'margin--right_8' }) })),
                                width: 100,
                                sortable: false,
                            },
                        ] })] }), selected && (_jsx(Card, { children: _jsx(CardContent, { children: _jsx(Filter, { value: selected, clientId: clientId, onComplete: () => setSelected(null) }) }) }))] }));
};
